import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import CarouselStyles from './style';

function CarouselImage({ imageUrl }) {
    return (
        <Box component="figure" sx={CarouselStyles.Image.container}>
            <Box component="img" src={imageUrl} alt="Carousel illustration" sx={CarouselStyles.Image.image} />
        </Box>
    );
}

CarouselImage.propTypes = {
    imageUrl: PropTypes.string.isRequired,
};

export default CarouselImage;
